import React from 'react'
import {Http} from 'common'


const TIMEOUT = 5 * 1000 * 60

export class CsrfToken extends React.Component {
    componentWillMount() {
        Http.setOnTokenFailure(this.refreshToken)
        this.refreshToken()
    }

    refreshToken = () => {
        const { onChange } = this.props

        Http.GET('csrf', r => {
            Http.setCsrfToken(r.token)
            onChange && onChange(r.token)

            setTimeout(this.refreshToken, TIMEOUT)
        })
    }

    render() {
        return (<span></span>)
    }
}
